import React, { useRef } from "react";
import AsyncSelect from "react-select/async";
import { stockPickerStyles, stockPickerTheme } from "./StockPicker.styles";
import styles from "./StockPicker.module.css";

/* ── Custom Option Row ── */
const StockOption = ({ innerRef, innerProps, data, isFocused, isSelected }) => (
  <div
    ref={innerRef}
    {...innerProps}
    className={`${styles.option} ${isFocused ? styles.optionFocused : ""} ${isSelected ? styles.optionSelected : ""}`}
  >
    <span className={styles.optionSymbol}>{data.symbol}</span>
    <span className={styles.optionName}>{data.name || data.label}</span>
    <span className={styles.exchangeBadge}>{data.exchange || "NSE"}</span>
  </div>
);

/* ── Custom Selected Value ── */
const StockSingleValue = ({ innerProps, data }) => (
  <div {...innerProps} className={styles.selectedChip}>
    <span className={styles.chipSymbol}>{data.symbol}</span>
    <span className={styles.chipSeparator}>·</span>
    <span className={styles.chipName}>{data.name || data.label}</span>
  </div>
);

/* ── No Options Message ── */
const NoOptionsMessage = ({ innerProps, selectProps }) => (
  <div {...innerProps} className={styles.noOptions}>
    {selectProps.inputValue
      ? `No stocks found for "${selectProps.inputValue}"`
      : "No stocks available"
    }
  </div>
);

/* ── Main Component ── */
const StockPicker = ({
  value,
  onChange,
  fetchStocks,
  label = "Link to Stock",
  placeholder = "Search stocks...",
  isOptional = true,
  disabled = false,
}) => {
  const selectRef = useRef(null);

  return (
    <div className={styles.wrapper}>
      {label && (
        <label className={styles.label}>
          {label}
          {isOptional && <span className={styles.optionalTag}>(optional)</span>}
        </label>
      )}
      <AsyncSelect
        ref={selectRef}
        cacheOptions
        defaultOptions
        loadOptions={fetchStocks}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        isClearable
        isDisabled={disabled}
        styles={stockPickerStyles}
        theme={stockPickerTheme}
        components={{
          Option: StockOption,
          SingleValue: StockSingleValue,
          NoOptionsMessage,
        }}
        menuPlacement="auto"
        maxMenuHeight={260}
      />
    </div>
  );
};

export default StockPicker;
